export const stripDivisionPrefix = (divisionLabel, folderLabel) => {
  /*this regex strips out the division whether
  a dash or a whitespace follows it*/
  const regex = new RegExp(`${divisionLabel}[-\\s]`, 'g');
  return folderLabel.replace(regex, '');
};

export const stripDivisionPrefixAndDash = (divisionLabel, folderLabel) => {
  /*this regex strips out the division *only* if a dash
  follows it. otherwise if it's followed by a whitespace
  (or any other character) the division stays in the label*/
  const regex = new RegExp(`${divisionLabel}-`, 'g');
  return folderLabel.replace(regex, '');
};

export const formatAmpersands = (s) => (s ? s.replace(/amp;/g, '') : '');

export const formatBreakInId = (id) => id.split('-')[0];

const splitOutDelimiters = (s) => s.split(/[,/]/).join(' ');

const containsLongWord = (s) => s.match(/\S+/g).some((el) => el.length > 14);

// This is to make the FolderDrawer view more presentable
export const formatWorkType = (workType) => {
  if (workType === undefined || workType === '') return '';
  workType = splitOutDelimiters(workType);
  workType = formatAmpersands(workType);
  return containsLongWord(workType)
    ? workType.substring(0, 15) + ' ...'
    : workType;
};

export const getDivisionsFromFolders = (foldersJson) => {
  const foldersObj = foldersJson.reduce((acc, folder) => {
    if (!folder.division) return acc;

    if (!acc[folder.division]) {
      acc[folder.division] = {
        name: folder.division,
        onCall: folder.onCall,
        folders: [],
      };
    }

    acc[folder.division].folders.push({
      folderName: folder.name,
      folderId: folder.id,
      active: folder.active,
    });

    acc[folder.division].hasActiveFolder = acc[folder.division].folders.some(folder => folder.active);
    return acc;
  }, {});
  return Object.values(foldersObj);
};

export const formatFieldMeetsAndStandbys = (
  docType,
  ticket,
  ticketID,
  fieldMeetID,
  _id
) => {
  return docType === 'fieldMeet'
    ? `Field Meet ${
        ticket
          ? `for ${ticket}`
          : ticketID
          ? `for ${ticketID.split('-')[0]}`
          : '(no ticket ID)'
      }`
    : `Standby for ${fieldMeetID ? fieldMeetID : _id}`;
};

export const getDivisionOptions = (foldersJson) => {
  const divisions = getDivisionsFromFolders(foldersJson);
  const filteredDivisions = divisions.filter((division) => division.hasActiveFolder);
  const divOptions = filteredDivisions.reduce((array, division) => {
    array.push({
      value: division.name,
      label: division.name,
      onCall: division.onCall,
      folderIDs: division.folders.map((folder) => folder.folderId),
    });
    return array;
  }, []);
  divOptions.sort((a, b) => a.value.localeCompare(b.value));
  return divOptions;
};

export const getFolderOptions = (division, foldersJson) => {
  const divisions = getDivisionsFromFolders(foldersJson);
  let folderOptionsArray = [{ value: '', label: '', sortOrder: ['', -1] }];
  const selectedDivision = divisions.find((obj) => obj.name === division.value);

  if (selectedDivision) {
    folderOptionsArray = selectedDivision.folders.reduce((array, folder) => {
      //As the folder name is a string localCompare sort will fail to sort trailing numbers. e.g. 10 will come before 2.
      //Therefore we want to split the trailing numbers from the folder name to be sorted separately.
      //Should the trailing number not exist, we add a faux value of -1.
      let sortOrder = folder.folderName.split(/(\d+)/);
      sortOrder = sortOrder.length >= 3 ? sortOrder : [sortOrder[0], -1];
      array.push({
        value: folder.folderId,
        label: folder.folderName,
        sortOrder,
      });
      return array;
    }, folderOptionsArray);
    folderOptionsArray.sort((folder1, folder2) => {
      const sortOrder1 = folder1.sortOrder;
      const sortOrder2 = folder2.sortOrder;
      const alphaLeadingString = sortOrder1[0].localeCompare(sortOrder2[0]);

      if (alphaLeadingString === 0) {
        const numericSortOrder = sortOrder1[1] - sortOrder2[1];
        if (numericSortOrder === 0) {
          return 0;
        }
        return numericSortOrder > 0 ? 1 : -1;
      }
      return alphaLeadingString;
    });
  }
  return folderOptionsArray;
};
